// extracted by mini-css-extract-plugin
export default {"wrapper":"Terms_wrapper__QqlYs","dashboard":"Terms_dashboard__-GgL7","feed":"Terms_feed__559WZ","content":"Terms_content__vVajC","header":"Terms_header__TUZOa"};